export enum CacheTag {
  css = 'css',
  oss = 'oss',
  excursionResource = 'excursionResource',
  getExcursionsBaseData = 'getExcursionsBaseData',
  getExcursionsSearchList = 'getExcursionsSearchList',
  getExcursionsSearchListByPort = 'getExcursionsSearchListByPort',
  pcl = 'pcl',
  bookinghub = 'bookinghub',
  airportResource = 'airportResource',
  airlineResource = 'airlineResource',
  busStationResource = 'busStationResource',
  tripResource = 'tripResource',
  portResource = 'portResource',
  regionResource = 'regionResource',
  shipResource = 'shipResource',
  cabinCategoryTypeResource = 'cabinCategoryTypeResource',
  getTripCabinTypesAndCategories = 'getTripCabinTypesAndCategories',
  getTripCabinTypesAndCategoriesByCabinCategoryCode = 'getTripCabinTypesAndCategoriesByCabinCategoryCode',
  getShipCabinTypesAndCategories = 'getShipCabinTypesAndCategories',
  getCabinCategoryTypes = 'getCabinCategoryTypes',
  getTripEvents = 'getTripEvents',
  getRegions = 'getRegions',
  getShipDetails = 'getShipDetails',
  getShips = 'getShips',
  getShipDecks = 'getShipDecks',
  getShipVenueCategories = 'getShipVenueCategories',
  getShipVenueCategory = 'getShipVenueCategory',
  getTripThemeContent = 'getTripThemeContent',
  getMultipleTripsDetails = 'getMultipleTripsDetails',
  getAirports = 'getAirports',
  getAirlines = 'getAirlines',
  getBusStations = 'getBusStations',
  getTrips = 'getTrips',
  getOfferData = 'getOfferData',
  getPort = 'getPort',
  getPortDetails = 'getPortDetails',
  getPorts = 'getPorts',
  auth = 'auth',
  authTokenRequest = 'authTokenRequest',
  venueResource = 'venueResource',
  getVenueDetails = 'getVenueDetails',
  getVenueCategories = 'getVenueCategories',
  getVenueCategory = 'getVenueCategory',
}
